import React from 'react'
import ChapterForm from './ChapterForm'
import {Modal} from 'react-bootstrap'


const ChapterNew = ({show,handleModalClose,handleSubmit}) => (
  <div>
    <Modal show={show} backdrop="static" keyboard={false} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Neues Kapitel</Modal.Title>
        </Modal.Header>
          <ChapterForm
             handleSubmit={handleSubmit}
            />
        </Modal>
  </div>
)

export default ChapterNew